import tvgConf from "@tvg/conf";
import requester from "../requester";
import getProtocol from "../protocolSetter";
import { serviceResponse } from "../types";

const payService: string = "service.pay";

const getToken = (
  accountNumber: string,
  amount: string,
  cancelUrl: string = "emptyUrl",
  returnUrl: string = "emptyUrl"
): Promise<serviceResponse> =>
  requester()({
    method: "POST",
    url: `${getProtocol()}${tvgConf().config(
      payService
    )}/users/${accountNumber}/token`,
    headers: { "x-tvg-context": tvgConf().context() },
    withCredentials: true,
    data: {
      cancelUrl,
      orderAmount: amount,
      returnUrl
    }
  });

const finishDeposit = (accountNumber: string, token: string) =>
  requester()({
    method: "POST",
    url: `${getProtocol()}${tvgConf().config(
      payService
    )}/users/${accountNumber}/deposits/${token}`,
    headers: { "x-tvg-context": tvgConf().context() },
    withCredentials: true
    // eslint-disable-next-line
  }) as Promise<any>;

// Braintree client token endpoint
const getBraintreeClientToken = (
  accountNumber: string
): Promise<serviceResponse> =>
  requester()({
    method: "POST",
    url: `${getProtocol()}${tvgConf().config(
      payService
    )}/users/${accountNumber}/client-token`,
    headers: { "x-tvg-context": tvgConf().context() },
    withCredentials: true
  });

// Braintree deposit completion with payment method nonce
const finishBraintreeDeposit = (
  accountNumber: string,
  paymentMethodNonce: string,
  amount: string,
  transactionUUID: string | undefined,
  payerId: string
): Promise<serviceResponse> => {
  // Fail fast if required parameters are empty or undefined
  if (!accountNumber || !paymentMethodNonce || !amount || !payerId) {
    return Promise.reject({
      response: {
        data: {
          code: "MISSING_REQUIRED_PARAMS"
        }
      }
    });
  }

  // Validate amount is a valid number
  const numericAmount = Number(amount);
  if (Number.isNaN(numericAmount) || numericAmount <= 0) {
    return Promise.reject({
      response: {
        data: {
          code: "INVALID_AMOUNT"
        }
      }
    });
  }

  const requestData = {
    nonce: paymentMethodNonce,
    amount: numericAmount,
    ...(transactionUUID && { transactionUUID }),
    payerId
  };

  return requester()({
    method: "POST",
    url: `${getProtocol()}${tvgConf().config(
      payService
    )}/users/${accountNumber}/deposit`,
    headers: { "x-tvg-context": tvgConf().context() },
    withCredentials: true,
    data: requestData
  });
};

const postWithdraw = ({
  accountNumber,
  amount
}: {
  accountNumber: string;
  amount: number;
}) =>
  requester()({
    method: "POST",
    url: `${getProtocol()}${tvgConf().config(
      payService
    )}/users/${accountNumber}/withdrawals`,
    headers: { "x-tvg-context": tvgConf().context() },
    withCredentials: true,
    data: {
      amount
    }
  });

const PAY_SERVICE = {
  getToken,
  finishDeposit,
  postWithdraw,
  getBraintreeClientToken,
  finishBraintreeDeposit
};

export default PAY_SERVICE;
